// extracted by mini-css-extract-plugin
export default {"difficultyHeader":"styles_difficultyHeader__EMFRn","arrowBack":"styles_arrowBack__F66Xs","buttons":"styles_buttons__jaYmb"};